<section *ngIf="isCardView">
    <div class="p-3 container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card rounded mb-2">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <p class="card-title">{{ selectedSchemeN ? selectedSchemeN.name + ' Proposals' : 'All Schemes' }}</p>
                        <div class="d-flex justify-content-end mb-2 mt-2">
                            <p-button *ngIf="selectedSchemeN" label="Back to Schemes" [outlined]="true" size="small" 
                                icon="pi pi-arrow-left" (onClick)="backToSchemes()" class="me-2"></p-button>
                                
                            <p-button  label="Initiate New Proposal" [outlined]="true" size="small" icon="pi pi-plus"
                                (onClick)="addProposal('new')" *ngIf="selectedSchemeN && activeTabIndex == 0 && '/master/proposal' | hasPermission: 'Add'"></p-button>

                            <p-button label="Initiate Existing Proposal" [outlined]="true" size="small" icon="pi pi-plus"
                                (onClick)="addProposal('existing')" *ngIf="selectedSchemeN && activeTabIndex != 0 && '/master/proposal' | hasPermission: 'Add'"></p-button>

                            <!-- <div class="ms-3 search-input d-flex align-items-center" *ngIf="selectedSchemeN">
                                <i class="pi pi-search me-2"></i>
                                <input type="text" class="form-control border-0" placeholder="Search ..."
                                  (input)="searchProposals($event)">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Scheme Cards View -->
                    <div *ngIf="!selectedSchemeN" class="row g-4">
                        <div class="col-12 col-md-6 col-lg-4" *ngFor="let scheme of schemes">
                            <!-- <div class="card scheme-card h-100 p-3 cursor-pointer" (click)="selectScheme(scheme)">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <p-tag severity="info" [value]="'Code: ' + scheme?.code"></p-tag>
                                    <p-tag [value]="scheme.scheme_data.total_proposal + ' Proposals'" severity="info" rounded></p-tag>
                                </div>
                                
                                <div class="ms-1">
                                    <h5 class="fw-bold mb-1">{{ scheme?.name }} Scheme</h5>
                                    <p class="text-muted-card small mb-3 description-truncate" [pTooltip]="scheme.description"
                                        tooltipPosition="top">
                                        {{ scheme.description }}
                                    </p>
                                </div>
                                
                                <div class="mt-auto">
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <div class="text-muted-card small">
                                            <i class="bi bi-clock me-1"></i> Created {{ scheme.created_on | date:'dd-MM-yyyy' }}
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                             <div class="card scheme-card h-100 p-3" >
                            <div class="d-flex flex-wrap align-items-center justify-content-between mx-1 my-2">
                                <div class="flex-grow-1 me-2 d-flex justify-content-between">
                                    <p-tag severity="danger" [rounded]="true" [value]="scheme.code " />
                                    <span pTooltip="Go to Proposal" (click)="selectScheme(scheme)"
                                        class="btn btn-light"><i class="pi pi-arrow-right"></i></span>
                                </div>
                                <!-- <div class="d-flex align-items-center">
                                    <p-button size="small" pTooltip="Create Proposal with {{scheme.name}} Scheme"
                                        (onClick)="addProposal(scheme)" icon="pi pi-plus"
                                        severity="contrast"></p-button>
                                </div> -->
                            </div>

                            <!-- Main body -->
                            <div class="card-body d-flex flex-column">
                                <div class="d-flex align-items-center mb-3">
                                    <h5 class="mb-0 ">{{scheme.name.toUpperCase()}} SCHEME</h5>
                                </div>

                                <!-- Description with ellipsis and tooltip -->
                                <p class="text-muted-card small mb-3 scheme-description" [pTooltip]="scheme.description"
                                    tooltipPosition="top">
                                    {{ scheme.description }}
                                </p>

                                <!-- Bottom content wrapped in mt-auto to push it down -->
                                <div class="mt-auto">
                                    <div class="d-flex gap-2 mb-3 flex-wrap justify-content-between">
                                        <span class="badge-box step-box">
                                            <i class="bi bi-flag me-1"></i>
                                            {{ scheme?.scheme_data.total_steps }}
                                            {{ scheme?.scheme_data.total_steps > 1 ? 'Steps' : 'Step' }}
                                        </span>

                                        <span class="badge-box proposal-box">
                                            <i class="bi bi-file-text me-1"></i>
                                            {{ scheme?.scheme_data.total_proposal }}
                                            {{ scheme?.scheme_data.total_proposal > 1 ? 'Proposals' : 'Proposal' }}
                                        </span>
                                    </div>

                                    <button class="btn btn-gradient-light w-100" (click)="addProposal('new' , scheme)">
                                        <i class="pi pi-plus-circle me-2"></i> Create Proposal with {{ scheme.name }}
                                    </button>
                                </div>


                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Proposal Tab View (shown when a scheme is selected) -->
                    <div *ngIf="selectedSchemeN">
                        <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
                            <p-tabPanel *ngFor="let tab of tabList; let tabIndex = index" [header]="tab.name">
                                <div class="row g-4">
                                    <div class="col-12 col-md-6 col-lg-4" *ngFor="let proposal of getPagedProposals(tabIndex)">
                                        <ng-container
                                            *ngTemplateOutlet="proposalCardTemplate; context: { $implicit: proposal }"></ng-container>
                                    </div>
                                </div>
                            </p-tabPanel>
                        </p-tabView>

                        <!-- Pagination -->
                        <div class="d-flex card justify-content-center mt-4">
                            <p-paginator [rows]="itemsPerPage" [totalRecords]="getFilteredProposals(activeTabIndex).length"
                                [first]="(currentPage-1)*itemsPerPage" (onPageChange)="onPageChange($event)">
                            </p-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #proposalCardTemplate let-proposal>
    <!-- Your existing proposal card template remains the same -->
    <div class="card scheme-card h-100 p-3">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
            <p-tag severity="info" [value]="proposal?.scheme?.name" class="mb-2 mb-sm-0"></p-tag>
            <div class="d-flex gap-3">
                <span (click)="deleteProposal(proposal)" class="btn btn-light" pTooltip="Delete Proposal"
                    tooltipPosition="top" *ngIf="('/master/proposal' | hasPermission: 'Delete') || proposal.can_edit == true"><i class="pi pi-trash delete-red"></i></span>
                <span (click)="updateProposal(proposal)" class="btn btn-light" pTooltip="Edit Proposal"
                    tooltipPosition="top" *ngIf="('/master/proposal' | hasPermission: 'Edit') || proposal.can_edit == true"><i class="pi pi-pencil"></i></span>
                <span (click)="navigateToSchemeTransaction(proposal , activePhaseId)" class="btn btn-light"
                    pTooltip="Go to Steps" tooltipPosition="top" *ngIf="'/master/proposal' | hasPermission: 'View'"><i class="pi pi-arrow-right"></i></span>
            </div>
        </div>

        <div class="ms-1">
            <h5 class="fw-bold mb-1">{{ proposal?.name }}</h5>
            <p class="text-muted-card small mb-3 description-truncate" [pTooltip]="proposal.description"
                tooltipPosition="top">
                {{ proposal.description }}
            </p>
        </div>

        <div class="mt-auto">
            <div class="d-flex justify-content-between small text-muted-card ms-1 mb-1">
                <span>Step {{ proposal.step_summary.completed_steps || 0 }}/{{ proposal.step_summary.total_steps || 0
                    }}</span>
                <span>{{ proposal.step_summary.completed_percentage }}% Complete</span>
            </div>
            <div class="progress ms-1 mb-3">
                <div class="progress-bar bg-primary" role="progressbar"
                    [style.width.%]="proposal.step_summary.completed_percentage" aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="text-muted-card small">
                    <i class="bi bi-clock me-1"></i> Created {{ proposal.created_on | date:'dd-MM-yyyy' }}
                </div>
                <p-tag [value]="proposal.proposal_status | uppercase" severity="success" rounded></p-tag>
            </div>

            <button class="btn btn-gradient w-100" (click)="navigateToScheme(proposal)">
                View Details
            </button>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="isDeleteProposal">
    <p-dialog header="Delete Proposal" [modal]="true" [(visible)]="isDeleteProposal" [style]="{ width: '30rem' }"
        [maximizable]="true">
        <div class="delete-dialog">
            <span>Are you sure , you want to delete {{selectedProposal.name}} proposal?</span>
            <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()">
            </p-button>
        </div>
    </p-dialog>
</ng-container>

<p-toast></p-toast>

<ng-container *ngIf="addProposalVisible">
    <p-dialog [maximizable]="true" [header]="getDialogHeader()" [modal]="true" [(visible)]="addProposalVisible"
        [style]="{ width: '70rem' }">
        <div class="mt-3">
            <!-- <p-steps [model]="items" [readonly]="false" [(activeIndex)]="activeIndex"
                (activeIndexChange)="onActiveIndexChange($event)" /> -->
            <div class="custom-stepper">
                <div *ngFor="let item of items; let i = index" class="step-item" [class.active]="i === activeIndex"
                    (click)="setActiveIndex(i)">
                    <div class="step-number">{{i + 1}}</div>
                    <div class="step-label">{{item.label}}</div>
                    <div class="step-connector" *ngIf="i < items.length - 1"></div>
                </div>
            </div>

            <div class="mt-4 mb-4">
                <!-- Step 1 Content -->
                <div *ngIf="items[activeIndex]?.label === 'Add Proposal'">
                    <form [formGroup]="proposalForm" class="mt-1">
                        <div class="row">
                            <div class="col-md-6 pt-3">
                                <!-- <p-floatLabel variant="in" class="mt-2"> -->
                                <label for="proposalName">Proposal Name <b class="text-danger">*</b></label>
                                <input pInputText id="proposalName" pSize="large" formControlName="proposalName"
                                    autocomplete="off" class="w-100" />
                                <div *ngIf="proposalForm.get('proposalName')?.invalid && proposalForm.get('proposalName')?.touched"
                                    class="text-danger mb-3">
                                    Proposal Name is required
                                </div>
                                <!-- </p-floatLabel> -->
                            </div>
                            <div class="col-md-6 pt-3">
                                <label class="ps-2" for="scheme">Select Scheme <b class="text-danger">*</b></label>
                                <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true" filterBy="name"
                                    optionLabel="name" placeholder="Select Scheme" [style]="{ 'width': '100%' }"
                                    [disabled]="isUpdateProposal" optionValue="id">
                                </p-dropdown>
                                <div *ngIf="proposalForm.get('scheme')?.invalid && proposalForm.get('scheme')?.touched"
                                    class="text-danger mb-3">
                                    Scheme selection is required
                                </div>
                            </div>

                            <!-- <div class="col-md-6 pt-3">
                                <label for="fund">Select Fund <b class="text-danger">*</b></label>
                                <p-dropdown inputId="fund" formControlName="fund" [options]="funds" [filter]="true" filterBy="major_head"
                                    optionLabel="major_head" placeholder="Select a Fund" [style]="{ 'width': '100%' }">
                                    <ng-template let-fund pTemplate="item">
                                        <div class="list-group-item list-group-item-action">
                                            {{ fund.major_head }} - <small>{{ fund.minor_head }}</small>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div> -->

                        </div>
                        <div class="mb-4 ms-1 px-1 w-100 pt-3 ">
                            <label for="over_label">Proposal Description <b class="text-danger">*</b></label>
                            <!-- <p-floatLabel class="mt-2"> -->
                            <textarea pInputTextarea id="over_label" rows="5" pSize="large"
                                formControlName="description" autocomplete="off" class="w-100" maxlength="100"></textarea>
                            <!-- </p-floatLabel> -->


                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" (click)="onSubmit()" class="btn btn-primary" [disabled]="proposalForm.invalid || proposalForm.pristine">Submit</button>
                        </div>
                    </form>
                </div>
                <!-- Award of Contract -->
                <!-- Step 2: Mandatory steps from previous phases -->
                <div *ngIf="items[activeIndex]?.label === 'Mandatory steps from Previous Phases'">
                    <div class="card p-3">
                        <div class="d-flex justify-content-between mb-3">
                            <h5 class="mb-3">Mandatory Steps from Previous Phases</h5>
                            <div class="d-flex justify-content-end">
                                <button type="button"
                                    (click)="navigateToSchemeTransaction(selectedProposal , tabList[0].id)"
                                    class="btn btn-primary">Fill Details</button>
                            </div>
                        </div>

                        <ng-container *ngFor="let phase of transactionPhaseStages">
                            <div class="border p-3 mb-4">
                                <h6 class="mb-3"><b>{{ phase.phase.name }}</b></h6>

                                <ng-container *ngFor="let stage of phase.stages; let i = index">
                                    <!-- Only show non-skipped (mandatory) steps -->
                                    <ng-container *ngIf="!stage.skipped">
                                        <div class="row align-items-center mb-3">
                                            <div class="col-auto">
                                                <input class="form-check-input border-primary" type="checkbox"
                                                    [id]="'stage' + i" name="targetStage" [checked]="true"
                                                    [disabled]="true" />
                                            </div>
                                            <div class="col">
                                                <label class="form-check-label" [for]="'stage' + i">
                                                    <div class="d-flex flex-column">
                                                        <span class="fw-medium">{{ stage.name }}</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                            </div>
                        </ng-container>
                        <div class="d-flex justify-content-end">
                            <button type="button" (click)="next() " class="btn btn-primary">Proceed</button>
                        </div>
                    </div>
                </div>





                <!-- Step 2 Content -->
                <div *ngIf="items[activeIndex]?.label === 'Skip Stages' && currentUserRoleId == '6'">
                    <div class="card p-3 mt-4 skip-stage-container">
                        <!-- Important Notice -->
                        <div class="alert alert-warning mb-4">
                            <i class="bi bi-exclamation-circle me-2"></i>
                            <strong>Important</strong>
                            <p class="mb-0 mt-1">Select steps to skip or proceed with all the steps shown below.
                                Skipping steps will remove those from the Proposal. This action cannot be undone.</p>
                        </div>


                        <!-- Stage Selection -->
                        <div class="mb-4">
                            <div class="d-flex justify-content-between">
                                <h6 class="mb-3">Select Target Step</h6>
                                <h6 class="mb-3">
                                    <span class="badge bg-primary px-3 py-2 fs-6">
                                        Allocated: {{ completionSum || 0 }}%
                                    </span>
                                </h6>
                            </div>
                            <!-- <div class="ms-3 text-end d-flex  justify-content-end" style="width: 120px;">
                                <small class="text-muted">
                                    Allocated: {{ (completionSum || 0) }}%
                                </small>
                            </div> -->

                            <div class="stages-list">
                                <div class="form-check mb-3" *ngFor="let stage of stages; let i = index">
                                    <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i"
                                        name="targetStage" [value]="stage.id" [(ngModel)]="stage.skipped"
                                        [disabled]="stage.id <= currentStage" />
                                    <label class="form-check-label w-100" [for]="'stage' + i">
                                        <div class="d-flex justify-content-between align-items-start">
                                            <div class="d-flex flex-column">
                                                <span class="fw-medium">
                                                    {{ stage.name }} -
                                                    <p-tag [value]="'step - ' + stage.sequence" severity="secondary"
                                                        rounded></p-tag>
                                                </span>
                                                <small class="text-muted-card">{{ stage.description }}</small>
                                            </div>

                                            <div class="d-flex align-items-end gap-3" *ngIf="!stage.skipped">
                                                <!-- Timeline Input -->
                                                <div class="">
                                                    <label class="form-label mb-1 small text-muted">Timeline
                                                        (weeks)</label>
                                                    <input type="number" class="form-control form-control-sm w-100px"
                                                        min="1" [(ngModel)]="stage.week_timeline"
                                                        placeholder="e.g. 2" />
                                                </div>

                                                <!-- Completion % Input -->
                                                <div class="w-120px">
                                                    <label class="form-label mb-1 small text-muted">Completion %</label>
                                                    <input type="number" class="form-control form-control-sm w-120px"
                                                        min="0" max="100" [(ngModel)]="stage.percentage"
                                                         (ngModelChange)="onCompletionChange()" placeholder="e.g. 20" />
                                                </div>
                                            </div>


                                        </div>
                                    </label>

                                    <!-- Textarea for skipped reason -->
                                    <div *ngIf="stage.skipped" class="mt-2">
                                        <textarea class="form-control" rows="3"
                                            placeholder="Enter reason for skipping this stage..."
                                            [(ngModel)]="stage.remark"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="completionSum > 100" class="text-danger mt-2">
                            Total completion percentage cannot exceed 100%.
                        </div>

                        <div *ngIf="anyCompletionEntered && !allCompletionFilled && !canSubmit()"
                            class="text-danger mt-2">
                            Please fill all Completion % fields if entering any.
                        </div>


                        <!-- Action Buttons -->
                        <div class="d-flex justify-content-end gap-2">
                            <button class="btn btn-light" (click)="addProposalVisible = false">Cancel</button>
                            <button class="btn btn-primary" (click)="confirmSkipStage();next()"
                                [disabled]="!canSubmit() || completionSum != 100 || (anyCompletionEntered && !allCompletionFilled)">
                                <i class="bi bi-skip-forward me-1"></i>
                                <!-- Skip Selected Steps -->
                                Proceed
                            </button>
                            <!-- <button class="btn btn-primary" 
                                  
                                  (click)="apiCallForTransaction()">
                              <i class="bi bi-skip-forward me-1"></i>
                              Skip to Transaction
                          </button> -->
                        </div>
                    </div>

                </div>
                <div *ngIf="items[activeIndex]?.label === 'Route Configuration'">

                    <div class="p-3 mt-4">
                        <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
                            <div class="row">
                                <div class="col-md-6 mb-3 ">
                                    <label>Steps</label>
                                    <p-dropdown [options]="filteredStagesList" formControlName="step" optionValue="id"
                                        optionLabel="name" placeholder="Select a Step" class="w-100"
                                        (onChange)="onStepChange($event)" [filter]="true" filterBy="name">
                                    </p-dropdown>
                                </div>
                                <div class="col-md-6 mb-3" *ngIf="!this.routeForm.get('approved')?.value">
                                    <label>Role</label>
                                    <p-dropdown [options]="roleList" formControlName="role" optionValue="id"
                                        optionLabel="name" placeholder="Select a Role" class="w-100"
                                        (onChange)="onRoleChange($event)" [filter]="true" filterBy="name">
                                    </p-dropdown>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Directorate</label>
                                    <p-dropdown [options]="unitList" formControlName="unit" optionValue="id"
                                        optionLabel="name" placeholder="Select a Directorate" class="w-100"
                                        (onChange)="onUnitChange($event)" [filter]="true" filterBy="name"
                                        appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>User</label>
                                    <p-dropdown [options]="userList" formControlName="user" optionValue="id"
                                        optionLabel="first_name" placeholder="Select a User" class="w-100"
                                        (onChange)="onUserChange($event)" [filter]="true" filterBy="first_name"
                                        appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="col-md-6 mb-3 flex-col" *ngIf="!this.routeForm.get('approved')?.value">
                                    <!-- <p-dropdown [options]="levelList" formControlName="level" optionValue="id" optionLabel="name"
                                      placeholder="Select a Level" class="w-100">
                                  </p-dropdown> -->
                                    <label for="menuIcon">Sequence</label>
                                    <input id="menuIcon" type="text" pInputText formControlName="level"
                                        placeholder="Enter Sequence" class="w-100" [disabled]="true" />
                                </div>
                                <div class="col-md-12 mb-3 d-flex justify-content-between">
                                    <div class=" mb-3 ad-user">
                                        <p-checkbox formControlName="approved" binary="true" inputId="ad_user"
                                            class="custom-checkbox me-3" (change)="onAllRolesSame(true)"></p-checkbox>
                                        <label for="ad_user"><b>Select only if you want the same user to be Initiator, Recommender, and Approver  for this step.</b></label>
                                    </div>
                                    <div class=" footer-btn  mt-6">
                                        <button pButton label="Submit" type="submit" class="fetch-data-btn" [disabled]="routeForm.invalid"></button>
                                    </div>
                                </div>

                            </div>
                        </form>



                        <!-- MAke it table here -->

                        <div class="mt-4  mb-4">
                            <ng-container *ngIf="RouteUserList?.length > 0">
                                <app-data-table [columns]="userCols" [data]="RouteUserList" [title]="'User Mapping'"
                                    [isDeletable]="true" (deleteEventRow)="deleteUser($event)" [showAddButton]="false"
                                    [showSearch]="false"></app-data-table>
                            </ng-container>
                        </div>
                    </div>

                </div>


            </div>


        </div>


    </p-dialog>
</ng-container>